/**
 * Handle the behavior of the grid exhibitions.
 */
const GridExhibitions = {
	/**
	 * Entry point
	 */
	_init: () => {
		// listen for document ready.
		document.addEventListener('DOMContentLoaded', GridExhibitions._ready);
	},
	/**
	 * Build grids after document load & listen for inpage nav clicks.
	 */
	_ready: () => {
		const grids = document.querySelectorAll('.gridexhibitions');
		if (grids.length) {
			grids.forEach(grid => {
				const exhibitionGrid = new GridExhibitions.Grid(grid);
				exhibitionGrid._init();
			});
		}

		const inpageNav = document.querySelector('.gridexhibitions-inpage');
		if (null !== inpageNav) {
			const links = inpageNav.querySelectorAll('a');
			if (links.length) {
				links.forEach(link => link.addEventListener('click', GridExhibitions._inpageNavClickHandler));
			}
			
			GridExhibitions._inpageNavScrollObserver();
		}

	},
	/**
	 * Scroll to grid anchor on click.
	 * @param {object} e the event object.
	 */
	_inpageNavClickHandler: (e) => {
		// prevent default hash/page jumping behavior.
		e.preventDefault();

		// update hash in URL without updating history.
		history.replaceState(undefined, undefined, e.target.href);

		const rootStyles = getComputedStyle(document.documentElement);
		const headerBarHeight = rootStyles.getPropertyValue('--header-height-expanded').trim();
		const NavHeight = rootStyles.getPropertyValue('--nav-height').trim();
		const headerNavHeight = (parseFloat(headerBarHeight) + parseFloat(NavHeight)) * 2;

		// scroll to div with hash for id.
		window.scrollTo({
			top: document.getElementById(window.location.hash.replace('#', '')).offsetTop - headerNavHeight,
			behavior: 'smooth'
		});
	},
	_inpageNavScrollObserver: () => {
		// get all the gridexhibitions-grid items.
		const observables = document.querySelectorAll('.gridexhibitions-grid');
		
		const rootStyles = getComputedStyle(document.documentElement);
		const headerBarHeight = parseFloat(rootStyles.getPropertyValue('--header-height').trim());
		const NavHeight = rootStyles.getPropertyValue('--nav-height').trim();
		const headerNavHeight = parseFloat(headerBarHeight) + parseFloat(NavHeight);

		const options = {
			root: null,
			rootMargin: `-${headerNavHeight}px 0px 0px 0px`,
			threshold: 0,
		}

		const exhGrids = new Map();
		let currentElement = null;
		let currentLink = null;

		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				exhGrids.set(entry.target, entry.intersectionRatio);
			});

			let chosenElement = null;
			let maxRatio = 0;

			exhGrids.forEach((ratio, element) => {
				if (ratio >= maxRatio) {
					chosenElement = element;
					maxRatio = ratio;
				} 
			});

			if (chosenElement && chosenElement !== currentElement) {
				if (currentLink) currentLink.classList.remove('active');
				currentElement = chosenElement;
				currentLink = document.querySelector(`.gridexhibitions-inpage-wrapper-link.${chosenElement.id}`);
				currentLink.classList.add('active');
			} else if (!chosenElement) {
				currentElement = null;
				currentLink = null;
				const inPageLinks = document.querySelectorAll('.gridexhibitions-inpage-wrapper-link');
				inPageLinks.forEach(link => link.classList.remove('active'));
			}
		}, options);

		observables.forEach(observable => {
			exhGrids.set(observable, 0);
			observer.observe(observable)
		});
	},
	/**
	 * The grid object that handles the behavior of the grid. set up this way in case there's randomly multiples of this block.
	 * @param {HTMLElement} container 
	 */
	Grid: function (container) {
		// hold the container
		this.container = container;

		/**
		 * Handle pointer move
		 * @param {object} e the event object
		 */
		this._pointerMoveHandler = (e) => {
			// set the arrow to the theme hovered over and update it's position.
			const { clientX, clientY } = e;
			const arrow = this.container.querySelector('.gridexhibitions-arrow');

			if (null !== arrow) {
				const arrowRect = arrow.getBoundingClientRect();

				arrow.style.top = `${clientY - arrowRect.height / 2}px`;
				arrow.style.left = `${clientX - arrowRect.width / 2}px`;

				arrow.dataset.theme = e.target.closest('.gridexhibitions-grid-item').dataset.theme;
			}
		}

		/**
		 * Handle pointer out
		 * @param {object} e the event object
		 */
		this._pointerOutHandler = (e) => {
			// set the arrow back to default theme.
			const arrow = this.container.querySelector('.gridexhibitions-arrow');
			if (null !== arrow) {
				arrow.dataset.theme = 'default';
			}
		}

		/**
		 * Entry point for the grid
		 */
		this._init = () => {
			// try to get grid items
			const grids = this.container.querySelectorAll('.gridexhibitions-grid');
			// if there's grid items
			if (grids.length) {
				// loop through them
				grids.forEach(grid => {
					// listen for mousemove and mouseout.
					grid.addEventListener('pointermove', this._pointerMoveHandler);
					grid.addEventListener('pointerout', this._pointerOutHandler);
				});
			}
		}
	},
}

// blast off.
GridExhibitions._init();